import { Grid, LinearProgress } from "@material-ui/core";
import React from "react";
import { StatsWidget } from "features/vms/vendorDashboard/StatsWidget/StatsWidget";
import { vendorStatsStyle } from "./style";
import { useGetVmsVendorStatsQuery } from "features/vms/vmsSlice";
import { VendorRating } from "features/vms/vendorFeedback/VendorRating";
import { IconClock, IconSettings, IconSquareCheck, IconSquareMoney, IconUserCheck } from "icons";

export const VendorStats = ({ vendorId }) => {
    const classes = vendorStatsStyle();
    let { data: stats, error, isFetching: isLoading } = useGetVmsVendorStatsQuery({
        id: vendorId
    });

    return (
        <>
            <Grid container item xs={12} spacing={2} >
                {[{
                    title: 'Overall Vendor Score',
                    statsText: stats?.overallScore?.toFixed(2) ?? 0,
                    content: <LinearProgress
                        style={{ height: 6, borderRadius: 3 }}
                        color="primary"
                        variant='determinate'
                        size="lg"
                        value={stats?.overallScore}
                    />,
                    trend: stats?.vendorScoreTrends?.overallScoreTrend,
                },
                {
                    title: 'Rework Rate',
                    statsText: `${(stats?.reworkRate * 100)?.toFixed(2) ?? 0}%`,
                    content: <LinearProgress
                        style={{ height: 6, borderRadius: 3 }}
                        color="primary"
                        variant='determinate'
                        size="lg"
                        value={stats?.reworkRate}
                    />,
                    icon: <IconSettings style={{ width: 12, marginRight: 8 }} />,
                    trend: stats?.vendorScoreTrends?.reworkRateScoreTrend * (-1),
                }, {
                    title: 'Service Turnaround Time',
                    statsText: (() => {
                        const hours = stats?.turnaroundTime ?? 0;
                        if (hours >= 24) {
                            const days = Math.floor(hours / 24);
                            const remHours = Math.round(hours % 24);
                            return `${days}d${remHours > 0 ? ` ${remHours}h` : ''}`;
                        }
                        return `${Math.round(hours)} hrs`;
                    })(),
                    icon: <IconClock fill="#0090fe" style={{ width: 12, marginRight: 8 }} />,
                    trend: stats?.vendorScoreTrends?.turnaroundTimeScoreTrend,
                }, {
                    title: 'On-Time Completion Score',
                    statsText: `${stats?.onTimeCompletionScore?.toFixed(2) ?? 0}%`,
                    content: <LinearProgress
                        style={{ height: 6, borderRadius: 3 }}
                        color="primary"
                        variant='determinate'
                        size="lg"
                        value={stats?.onTimeCompletionScore}
                    />,
                    icon: <IconSquareCheck style={{ width: 12, marginRight: 8 }} />,
                    trend: stats?.vendorScoreTrends?.onTimeCompletionScoreTrend,
                }, {
                    title: 'Cost Trend Analysis',
                    statsText: `${stats?.costTrendScore?.toFixed(2) ?? 0}%`,
                    content: <LinearProgress
                        style={{ height: 6, borderRadius: 3 }}
                        color="primary"
                        variant='determinate'
                        size="lg"
                        value={stats?.costTrendScore}
                    />,
                    icon: <IconSquareMoney style={{ width: 12, marginRight: 8 }} />,
                    trend: stats?.vendorScoreTrends?.costTrendScoreTrend,
                }, {
                    title: 'Client Satisfaction Score',
                    content: <div style={{ display: 'flex' }}><VendorRating value={stats?.satisfaction ?? null} readOnly />
                        <label style={{ color: '#0061a9' }}>{` (${stats?.satisfaction?.toFixed(1) ?? 0})`}</label>
                    </div>,
                    icon: <IconUserCheck style={{ width: 13, marginRight: 8 }} />,
                }].map((props, idx) => (
                    <Grid item key={props.title} style={{ flex: 1, minWidth: 0 }}>
                        <StatsWidget isLoading={isLoading} {...props} noShadow />
                    </Grid>
                ))}
            </Grid>

        </>
    )
}
